import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_v_card_item, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
            : (_openBlock(), _createBlock(_component_v_form, {
                key: 1,
                onSubmit: _withModifiers(_ctx.getReportData, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { md: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.searchDto.year,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchDto.year) = $event)),
                            label: "Fiscal Year",
                            items: _ctx.fiscalYears,
                            "item-value": "year",
                            "item-title": "text"
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { md: "8" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_autocomplete, {
                            modelValue: _ctx.searchDto.programIds,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchDto.programIds) = $event)),
                            label: "Treatment Programs",
                            items: _ctx.userAttachedPrograms,
                            "item-value": "treatmentProgramId",
                            "item-title": "description",
                            multiple: "",
                            clearable: "",
                            "closable-chips": ""
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { md: "2" }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            color: "info",
                            onClick: _ctx.getReportData,
                            disabled: _ctx.isSearching || !_ctx.searchDto.year
                          }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode("Get Report Data", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick", "disabled"])), [
                            [_directive_ripple]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onSubmit"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}